import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import { useEffect, useState } from 'react'
export const FullImageView = props => {
  const [isVideo, setIsVideo] = useState(false)

  useEffect(() => {
    // Check if the source is a video format
    if (props?.src) {
      const videoExtensions = ['.mp4', '.webm', '.ogg', '.avi', '.mov', '.wmv', '.flv', '.mkv']
      const isVideoFormat = videoExtensions.some(ext => 
        props.src.toLowerCase().includes(ext.toLowerCase())
      )
      setIsVideo(isVideoFormat)
    }
  }, [props?.src])

  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header>
        <Modal.Title id='contained-modal-title-vcenter'>
          {isVideo ? 'Video Preview' : 'Image Preview'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isVideo ? (
          <video 
            width='100%' 
            controls 
            style={{ maxHeight: '70vh', objectFit: 'contain' }}
          >
            <source src={props?.src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <img 
            width='100%' 
            src={props?.src} 
            style={{ maxHeight: '70vh', objectFit: 'contain' }}
            alt="Preview"
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outlined' onClick={props.onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
